import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSEO } from "@/hooks/useSEO";
import { Logo } from "@/components/Logo";
import { CtaPrimary } from "@/components/CTA";

export default function AdminLogin() {
  useSEO({ title: "Admin | BlackSilex", noindex: true });
  const { user, ready, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (ready && user) navigate("/admin"); }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-coal grain flex items-center justify-center px-6" data-testid="admin-login">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="relative w-full max-w-md border border-offwhite/10 bg-nearblack p-10 lg:p-12">
        <Logo />
        <p className="tech-label text-strike mt-8">Admin Access</p>
        <h1 className="font-display font-black uppercase tracking-tight text-4xl text-offwhite mt-3">Control Room</h1>
        <form onSubmit={submit} className="mt-10 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block tech-label text-mutedgray mb-3">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full bg-coal border border-steel px-5 py-4 text-offwhite focus:outline-none focus:border-strike transition-colors"
              data-testid="admin-email" placeholder="admin@blacksilex.com" />
          </div>
          <div>
            <label className="block tech-label text-mutedgray mb-3">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full bg-coal border border-steel px-5 py-4 text-offwhite focus:outline-none focus:border-strike transition-colors"
              data-testid="admin-password" placeholder="••••••••" />
          </div>
          {error && <p className="text-strike font-mono-tech text-xs" data-testid="admin-error">{error}</p>}
          <div className="pt-2">
            <CtaPrimary type="submit" testId="admin-submit" className="w-full justify-center">{busy ? "Authenticating…" : "Enter"}</CtaPrimary>
          </div>
        </form>
      </div>
    </div>
  );
}
